import type JCE from '@chesscom/js-chess-engine';

/**
 * Check if the game is in the "claimable draw" state.
 */
export function isClaimableDraw(game: JCE.Game): boolean {
  return game.inThreefoldRepetition() || game.in50MoveRule();
}
